import React from 'react';
import MainMenu from 'components/common/mainmenu';
import API from "./api";
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
const APIContainer = () => {
    return (
        <div className="overwrite--modal--depth">
            <StickyMenu
                withStickyHeader={false}
            >
                <MainMenu
                    overviewIsActive={false}
                    comparisonIsActive={false}
                    onlyLeftMenu={true}
                />
                <StatsMenu
                    leftItemBold="SenzoAPI"
                />

            </StickyMenu>
            <div className="page-content">
                <div className="white-box-container box--shadow bg--white api--box">
                    <API />
                </div>
            </div >

        </div >
    );
}
export default (APIContainer);



// WEBPACK FOOTER //
// ./src/components/pages/api/index.jsx